import { render, staticRenderFns } from "./ExpertData.vue?vue&type=template&id=271a4b14&scoped=true"
import script from "./ExpertData.vue?vue&type=script&lang=js"
export * from "./ExpertData.vue?vue&type=script&lang=js"
import style0 from "./ExpertData.vue?vue&type=style&index=0&id=271a4b14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a4b14",
  null
  
)

export default component.exports